/** Plain-language definition of ET₀, reused wherever the term appears. */
export const ET0_HELP =
  "ET₀ — reference evapotranspiration: the depth of water (in mm) a healthy, well-watered lawn loses to evaporation and plant transpiration in a day. It's the “demand” side of the water balance — higher when it's hot, dry, sunny or windy — and it's what rain and irrigation have to replace.";

/** Renders “ET₀” with a dotted underline + hover tooltip explaining the term. */
export function Et0() {
  return (
    <abbr
      title={ET0_HELP}
      style={{ textDecoration: "none", borderBottom: "1px dotted currentColor", cursor: "help" }}
    >
      ET₀
    </abbr>
  );
}
